import config from 'message-control/config'

const newJavaApi = `${config.apiHost}/oem-crm_new_java`

export default {
    list: {
        url: `${newJavaApi}/api/risk-management/sensitive-word`,
        type: 'GET',
    },
    create: {
        url: `${newJavaApi}/api/risk-management/sensitive-word`,
        type: 'POST',
    },
    remove: {
        url: `${newJavaApi}/api/risk-management/sensitive-word/{id}`,
        type: 'DELETE',
    },
}
